import { render, staticRenderFns } from "./TypeChat.vue?vue&type=template&id=243cdb5d"
import script from "./TypeChat.vue?vue&type=script&lang=js"
export * from "./TypeChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports